import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { surveyServiceUrl } from "../Config";
import { submitSurveyCustomForm } from "../ApiCalls";
import SuccessIcon from "../../../../assets/svg/forms/success.inline.svg";
import ArrowRight from "../../../../assets/svg/icons/arrow-right-button.inline.svg";

const SurveyDpvdForm = () => {
  const {register, handleSubmit, formState: {errors, isSubmitting}} = useForm({mode: "onChange"});
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const onSubmit = (values) => {
    let formdata = new FormData();
    formdata.append("site_usability", values.site_usability);
    formdata.append("games_system", values.games_system);
    formdata.append("staff_friendly", values.staff_friendly);
    formdata.append("staff_effective", values.staff_effective);
    formdata.append("overall_satisfaction", values.overall_satisfaction);
    formdata.append("message", values.message);

    submitSurveyCustomForm(surveyServiceUrl, formdata, setSuccessMsg, setErrorMsg)
      .catch((error) => new Error(error));
  }

  return (
    <div className="form-wrapper custom-form-wrapper">
      {!successMsg &&
        <>
          <h2>แบบประเมินความพึงพอใจ</h2>
          <p>สำหรับลูกค้าใช้บริการสอบถามข้อมูล หรือแก้ไขปัญหา</p>
          <p className="orange">*Required</p>
        </>

      }
      {successMsg ?
        <div className="success-block a-center">
          <SuccessIcon/>
          <div className="success-text a-center">
            <h2 className="a-center success-block-header">{successMsg}</h2>
          </div>
        </div>
        :
        <form onSubmit={handleSubmit(onSubmit)} className="survey-form">
          {errorMsg && <p className="error-msg">{errorMsg}</p>}

          <h4 className="input-title">ความพึงพอใจต่อเว็บไซต์ของเรา *</h4>
          <div className={errors.site_usability ? "complex-input has-error" : "complex-input"}>
            <div className="question">การใช้งานเว็ปไซด์สะดวก ไม่ยุงยาก</div>
            <div className="input-wrap minimal-custom-radio-vertical">
              <div className="radio-wrap">
                <input type="radio" name="site_usability" id="site-usability-1" value={"1"}
                       {...register("site_usability", {required: true})} />
                <label htmlFor={"site-usability-1"}>{"1"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="site_usability" id="site-usability-2" value={"2"}
                       {...register("site_usability", {required: true})}/>
                <label htmlFor={"site-usability-2"}>{"2"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="site_usability" id="site-usability-3" value={"3"}
                       {...register("site_usability", {required: true})}/>
                <label htmlFor={"site-usability-3"}>{"3"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="site_usability" id="site-usability-4" value={"4"}
                       {...register("site_usability", {required: true})}/>
                <label htmlFor={"site-usability-4"}>{"4"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="site_usability" id="site-usability-5" value={"5"}
                       {...register("site_usability", {required: true})}/>
                <label htmlFor={"site-usability-5"}>{"5"}</label>
              </div>
            </div>
          </div>

          <div className={errors.games_system ? "complex-input has-error" : "complex-input"}>
            <div className="question">ระบบของเกมมีความถูกต้องและรวดเร็ว</div>
            <div className="input-wrap minimal-custom-radio-vertical">
              <div className="radio-wrap">
                <input type="radio" name="games_system" id="games-system-1" value={"1"}
                       {...register("games_system", {required: true})}/>
                <label htmlFor={"games-system-1"}>{"1"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="games_system" id="games-system-2" value={"2"}
                       {...register("games_system", {required: true})}/>
                <label htmlFor={"games-system-2"}>{"2"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="games_system" id="games-system-3" value={"3"}
                       {...register("games_system", {required: true})}/>
                <label htmlFor={"games-system-3"}>{"3"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="games_system" id="games-system-4" value={"4"}
                       {...register("games_system", {required: true})}/>
                <label htmlFor={"games-system-4"}>{"4"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="games_system" id="games-system-5" value={"5"}
                       {...register("games_system", {required: true})}/>
                <label htmlFor={"games-system-5"}>{"5"}</label>
              </div>
            </div>
          </div>

          <h4 className="input-title">ความพึงพอใจต่อเจ้าหน้าที่ผู้ให้บริการ *</h4>
          <div className={errors.staff_friendly ? "complex-input has-error" : "complex-input"}>
            <div className="question">เจ้าหน้าที่มีความสุภาพ เป็นมิตร ยินดีให้บริการ่</div>
            <div className="input-wrap minimal-custom-radio-vertical">
              <div className="radio-wrap">
                <input type="radio" name="staff_friendly" id="staff-friendly-1" value={"1"}
                       {...register("staff_friendly", {required: true})}/>
                <label htmlFor={"staff-friendly-1"}>{"1"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_friendly" id="staff-friendly-2" value={"2"}
                       {...register("staff_friendly", {required: true})}/>
                <label htmlFor={"staff-friendly-2"}>{"2"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_friendly" id="staff-friendly-3" value={"3"}
                       {...register("staff_friendly", {required: true})}/>
                <label htmlFor={"staff-friendly-3"}>{"3"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_friendly" id="staff-friendly-4" value={"4"}
                       {...register("staff_friendly", {required: true})}/>
                <label htmlFor={"staff-friendly-4"}>{"4"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_friendly" id="staff-friendly-5" value={"5"}
                       {...register("staff_friendly", {required: true})}/>
                <label htmlFor={"staff-friendly-5"}>{"5"}</label>
              </div>
            </div>
          </div>

          <div className={errors.staff_effective ? "complex-input has-error" : "complex-input"}>
            <div className="question">เจ้าหน้าที่สามารถแก้ปัญหาได้ถูกต้อง ตรงประเด็น</div>
            <div className="input-wrap minimal-custom-radio-vertical">
              <div className="radio-wrap">
                <input type="radio" name="staff_effective" id="staff-effective-1" value={"1"}
                       {...register("staff_effective", {required: true})}/>
                <label htmlFor={"staff-effective-1"}>{"1"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_effective" id="staff-effective-2" value={"2"}
                       {...register("staff_effective", {required: true})}/>
                <label htmlFor={"staff-effective-2"}>{"2"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_effective" id="staff-effective-3" value={"3"}
                       {...register("staff_effective", {required: true})}/>
                <label htmlFor={"staff-effective-3"}>{"3"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_effective" id="staff-effective-4" value={"4"}
                       {...register("staff_effective", {required: true})}/>
                <label htmlFor={"staff-effective-4"}>{"4"}</label>
              </div>
              <div className="radio-wrap">
                <input type="radio" name="staff_effective" id="staff-effective-5" value={"5"}
                       {...register("staff_effective", {required: true})}/>
                <label htmlFor={"staff-effective-5"}>{"5"}</label>
              </div>
            </div>
          </div>

          <h4 className="input-title">โดยภาพรวมท่านพึงพอใจในการให้บริการของเราหรือไม่? *</h4>
          <div className="field-wrap">
            {errors.overall_satisfaction && errors.overall_satisfaction.type === "required" &&
            <div className="error">จำเป็นต้องใช้</div>
            }
            <div className="minimal-custom-radio">
              <div className="radio-wrap">
                <input
                  type="radio"
                  value="Yes"
                  id="overall-satisfaction-1"
                  name="overall_satisfaction"
                  {...register("overall_satisfaction", {required: true})}
                />
                <label className={"white-label"} htmlFor="overall-satisfaction-1">Yes</label>
              </div>
              <div className="radio-wrap">
                <input
                  type="radio"
                  value="No"
                  id="overall-satisfaction-2"
                  name="overall_satisfaction"
                  {...register("overall_satisfaction", {required: true})}
                />
                <label className={"white-label"} htmlFor="overall-satisfaction-2">No</label>
              </div>
            </div>
          </div>


          <h4 className="field-title">ข้อเสนอแนะและคำติชม</h4>
          <div className="field-wrap">
            {errors.message && errors.message.type === "required" &&
            <div className="error">จำเป็นต้องใช้</div>
            }
            <textarea
              id={"message"}
              name="message"
              rows="5"
              placeholder=""
              {...register("message")}
            />
          </div>




          <div className="form-buttons flex">
            <button className="gradient-button" aria-label="ส่งข้อมูล"
                    disabled={isSubmitting} type="submit">
              <span>ส่งข้อมูล</span>
              <ArrowRight/>
            </button>
          </div>
        </form>
      }
    </div>
  );
}

export default SurveyDpvdForm;
